import React, { createContext, useState, useContext, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { rtdb } from '../index';
import { useAuth } from './AuthContext';

const AppConfigContext = createContext({});

export const AppConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({});
  const [configLoading, setConfigLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      setConfig({});
      setConfigLoading(false);
      return;
    }

    const loadConfig = async () => {
      try {
        const snapshot = await get(ref(rtdb, '/config'));
        if (snapshot.exists()) {
          setConfig(snapshot.val());
        }
      } catch (error) {
        console.error('Error loading app config from RTDB:', error);
      } finally {
        setConfigLoading(false);
      }
    };

    loadConfig();
  }, [user]);

  return (
    <AppConfigContext.Provider value={{ config, configLoading }}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useAppConfig = () => useContext(AppConfigContext);
